<div class="form-modal modal-theme">
  <h1 mat-dialog-title>{{'HISTORY'|translate}}</h1>
  <div mat-dialog-content>
    <div class="form-horizontal modal-dialog-custom">
      <div class="row">
        <div class="col-sm-12">
          <div *ngIf="changes">
            <generic-table [data]="changes" [displayedColumns]="displayedColumns" [inputColumns]="inputColumns" [pageSize]="10" [actions]="false"></generic-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>